module.exports = __webpack_public_path__ + "media/assets/img/oferte-c9eae76bc14a3155677a4768bedcd501.svg";